<template>
  <div class="footer_wrap">


    <div class="footer">
     <span>
          <a :href="contactURL"> 联系我们 </a>
          <a :href="privacyURL">|  隐私政策 </a>
          <a :href="termsOfUseURL">|  服务协议 | </a>

          ©2021 上海移宇科技有限公司 版权所有<br/>
          <a target=_blank href="http://beian.miit.gov.cn/"> 沪ICP备08013753号-3  </a>
          <img src="/static/beian.png" />
          <a target=_blank href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"> 沪公网安备 31011502014155号 </a>
     </span>
    </div><!--footer 结束-->


    <div style="height: 50px;">
    </div>
  </div> <!--container结束-->
</template>

<script>
  // import echarts from 'echarts'
  import auth from '../auth/auth'
  export default {
    data() {
      return {
        contactURL:'',
        privacyURL:'',
        termsOfUseURL:'',
        username:'xxxxx'
      }
    },
    computed:{
      // getLanguage(){
      //
      // }
    },
    watch:{
      // getLanguage(val){
      //
      // }
    },
    mounted(){

      setTimeout(()=>{
        // let host=auth.getOuterHost();
        let host='https://www.medtrum.com.cn'
        this.contactURL = host+'/contact.html';
        this.privacyURL = host+'/privacy_policy.html';
        this.termsOfUseURL = host + '/terms_of_use.html';
      }, 50);

    },
    methods: {

    },
  }
</script>

<style scoped>


  p,body,html {
    margin:0;
  }

  .footer_wrap {
    width:800px;
    margin: 0 auto;
    margin-top:30px;
  }

  .footer{
    height:21px;
    width:80%;
    margin:8.5% auto 0;
    font-size:18px;
    /*color:rgba(246,248,251,0.90);*/
    color:#333;
    letter-spacing:-0.54px;
    text-align:center;
    font-family: SFUIText-Regular;
  }
  .footer a{
    /*color:rgba(246,248,251,0.90);*/
    color:#333;
    text-decoration: none;
  }
  .footer a:hover{
    color:#0090D3;
  }


</style>



// WEBPACK FOOTER //
// ReportFooter.vue?054b719e